import React from 'react'
import Topbar from './MainPage/Topbar'
import MainPage from './MainPage/MainPage'

function App() {
  return (
    <div className="wrapper">
      <Topbar />

      <MainPage />
    </div>
  )
}

export default App
